module.exports = __webpack_public_path__ + "static/earthly_twitter-card-adc2339b26645f72566e7066a5548e3d.png";